<template>
  <router-view />
  <NetworkStatusDialog/>
</template>
<script setup></script>

<style scoped></style>
